<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container">
        <a class="navbar-brand icon-img-100" [routerLink] = "'/'">
            <img [src]="logo" alt="Logo" class="logo">
        </a>
        <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNavAltMarkup">
            <ul class="navbar-nav navbar-center xs-mt-20">
                <li class="nav-item"> 
                    <a class="nav-link" (click)="scrollToSection('home')">Početna</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('aboutObject')">O objektu</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('aboutUs')">O nama</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('view')">Pregled objekta</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('tehnical')">Tehnički podaci</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('contact')">Kontakt</a>
                </li>
            </ul>
        </div>
        
    </div>
</nav>